{
  "greeting": "Hej! Hvordan kan jeg hjælpe dig med vin i dag?",
  "thinking": "✨ Tænker...",
  "thinkingStep": "✨ Finder det perfekte match til dig…🍷",
  "askAboutWine": "F.eks. 1990'erne Bordeaux rød ca. $1500 | Bourgogne landsby hvid under $600",
  "askAboutWineFirst": "Jeg vil gerne købe (region + farve + årgang + budget)",
  "waitingForResponse": "Venter på svar...",
  "dailyLimitReached": "Du har nået den daglige rådgivningsgrænse. Kom venligst tilbage efter 00:00 HKT for at fortsætte.",
  "chatHistory": "Din chathistorik",
  "noChatHistory": "Ingen chathistorik endnu",
  "startConversation": "Start en samtale for at se den her",
  "backToChat": "Tilbage til chat",
  "newChat": "Ny chat",
  "history": "Historik",
  "search": "Søg",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Vinrådgiver",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} vin anbefalet",
  "winesRecommended": "{count} vine anbefalet",
  "justNow": "Lige nu",
  "minuteAgo": "{count} minut siden",
  "minutesAgo": "{count} minutter siden",
  "hourAgo": "{count} time siden",
  "hoursAgo": "{count} timer siden",
  "dayAgo": "{count} dag siden",
  "daysAgo": "{count} dage siden",
  "noMessagesYet": "Ingen beskeder endnu",
  "perBottle": "Per flaske",
  "priceNA": "Pris ikke tilgængelig",
  "buyNow": "Køb nu",
  "moreInformation": "Mere information",
  "share": {
    "button": "Del",
    "title": "Del samtale",
    "description": "Del denne samtale med dine venner ved hjælp af linket nedenfor:",
    "generating": "Genererer delingslink...",
    "error": "Kunne ikke generere delingslink",
    "copy": "Kopiér",
    "copied": "Kopieret!",
    "note": "Bemærk: Dette link udløber om 30 dage. Når nogen åbner dette link, vil de se en kopi af denne samtale."
  },
  "checkOutWine": "Tjek denne vin: {name} {vintage}",
  "linkCopied": "Link kopieret til udklipsholder!",
  "contactWhatsApp": "Kontakt os på WhatsApp for flere muligheder",
  "errorLoadingWine": "Beklager, jeg kunne ikke indlæse vindetaljerne.",
  "errorOccurred": "Der opstod en fejl under hentning af svaret.",
  "you": "Dig",
  "welcome": {
    "intro": "Velkommen til WWX, jeg er Zyra, din AI-vinrådgiver. Du kan få adgang til:",
    "features": {
      "globalMarket": "Globalt finvinmarked (UK, FR, HK sælgere)",
      "realTimeOffers": "Realtids bedste tilbud inden for dit budget",
      "personalized": "Personlige anbefalinger kun til dig",
      "comparison": "Nem sammenligning af årgange og mærker",
      "instantCheckout": "Øjeblikkelig mængde og forsendelseskasse"
    },
    "question": "Hvad kan jeg anbefale dig i dag?",
    "trendingPrompts": "Eksempler på forespørgsler",
    "promptExamples": {
      "title": "Sådan spørger du:",
      "good": "✓ Gode eksempler:",
      "bad": "✗ Undgå forespørgsler uden budget:"
    },
    "prompts": {
      "bordeaux": "Bordeaux rød ca. $800",
      "champagne": "Grower champagne under $2000",
      "firstGrowth": "Bedste tilbud first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "Dette var nyttigt",
    "notHelpful": "Dette var ikke nyttigt",
    "thankYou": "Tak for din feedback!",
    "whatDidYouLike": "Hvad kunne du lide?",
    "whatCouldBeImproved": "Hvad kunne forbedres?",
    "category": "Kategori",
    "selectCategory": "Vælg en kategori",
    "categories": {
      "accuracy": "Nøjagtighed",
      "helpfulness": "Hjælpsomhed",
      "responseSpeed": "Svarhastighed",
      "clarity": "Klarhed",
      "other": "Andet"
    },
    "comments": "Kommentarer",
    "placeholder": "Fortæl os mere om din oplevelse...",
    "cancel": "Annullér",
    "submit": "Indsend feedback",
    "submitting": "Indsender..."
  },
  "auth": {
    "limitReached": "Daglig grænse nået",
    "signUpToday": "Tilmeld dig for flere beskeder",
    "limitMessage": "Du har nået din daglige beskedgrænse. Tilmeld dig en gratis konto for at fortsætte chatten.",
    "benefitsMessage": "Opret en gratis konto for at fortsætte med at chatte og gemme din chathistorik på tværs af enheder.",
    "remainingMessages": "Du har {count} beskeder tilbage i dag",
    "signUp": "Tilmeld dig",
    "login": "Log ind",
    "loggedInAs": "Logget ind som {email}",
    "logout": "Log ud"
  }
}
